import React, { useEffect } from 'react';
import './CurrencyConverter.css';

function CurrencyConverter() {
  // Handle iframe height adjustments when receiving messages
  useEffect(() => {
    const handleMessage = (message) => {
      const frames = document.querySelectorAll('iframe');
      const widgetFrame = frames[frames.length - 1];
      
      if (message.source !== widgetFrame.contentWindow) {
        return;
      }
      
      if (message.data && message.data.height) {
        widgetFrame.setAttribute('height', message.data.height);
      }
    };

    window.addEventListener('message', handleMessage);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div className="currency-converter-page">
      <div className="container">
        <div className="currency-converter-header">
          <h1>Currency Converter</h1>
          <p>Convert between USD and other currencies with real-time exchange rates</p>
        </div>
        
        <div className="converter-widget-container">
          <iframe
            title="fx"
            src="https://wise.com/gb/currency-converter/fx-widget/converter?sourceCurrency=USD&targetCurrency=EUR&amount=1"
            height="490"
            width="100%"
            frameBorder="0"
            allowTransparency="true"
          ></iframe>
        </div>
        
        <div className="converter-info">
          <h2>About Our Currency Converter</h2>
          <p>
            This tool provides real-time currency conversion using market rates from Wise. 
            Perfect for international businesses and startups managing global transactions.
          </p>
          <ul>
            <li>Updated exchange rates</li>
            <li>Support for multiple currencies</li>
            <li>Easy to use interface</li>
            <li>Reliable and transparent conversions</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CurrencyConverter; 